module.exports = __webpack_public_path__ + "static/Automate-Patient-Journey-cdc4211b205eb9d931e321a5d7aba5cc.jpg";